import React from "react";
import Steps from "./Steps";
import { useState } from "react";

const CompanyDetailsForm2 = ({ setFormNum, setFormData, username, email, formData }) => {
  const [file, setFile] = useState(null);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFormData((prevState) => ({ ...prevState, logo: selectedFile }));
    }
  };

  const handleRemoveFile = (e) => {
    e.preventDefault(); // Prevent form submission
    setFile(null);
    setFormData((prevState) => {
      const newState = { ...prevState };
      delete newState.logo;
      return newState;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleBackClick = () => {
    setFormNum((prev) => prev - 1);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const requiredFields = [
      "region",
      "country",
      "address",
      "zipcode",
      "website",
    ];
    setFormData((prevFormData) => {
      const missingFields = requiredFields.filter(
        (field) => !prevFormData?.[field] || prevFormData[field].trim() === ""
      );
      if (missingFields.length > 0) {
        alert(`Please fill all required fields: ${missingFields.join(", ")}`);
        return prevFormData;
      }
      setFormNum((prev) => prev + 1);
      return prevFormData;
    });
  };

  return (
    <div className="font-inter flex justify-center items-center">
      <div className="w-full max-w-lg xl:max-w-2xl bg-white p-4 sm:px-0">
        <Steps stepNum={2} setFormNum={setFormNum} />
        <h2 className="text-xl md:text-2xl 2xl:text-3xl 2xl:mb-4 2xl:ml-1 mb-4 font-semibold text-[#111827]">
          Company Details
        </h2>
        <form className="w-full text-[#5F5F5F]" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Username*"
            value={username}
            className="w-full px-4 py-2 2xl:py-3 2xl:text-lg mb-4 border border-[#CAD0D9] rounded-lg"
            readOnly={true}
          />
          <input
            type="email"
            placeholder="Email*"
            value={email}
            className="w-full px-4 py-2 2xl:py-3 2xl:text-lg mb-4 border border-[#CAD0D9] rounded-lg"
            readOnly={true}
          />
          <input
            type="text"
            placeholder="Region*"
            name="region"
            value={formData.region}
            className="w-full px-4 py-2 2xl:py-3 2xl:text-lg mb-4 border border-[#CAD0D9] rounded-lg"
            onChange={handleChange}
            required
          />
          <input
            type="text"
            placeholder="Country*"
            name="country"
            value={formData.country}
            className="w-full px-4 py-2 2xl:py-3 2xl:text-lg mb-4 border border-[#CAD0D9] rounded-lg"
            onChange={handleChange}
            required
          />
          <input
            type="text"
            placeholder="Address*"
            name="address"
            value={formData.address}
            className="w-full px-4 py-2 2xl:py-3 2xl:text-lg mb-4 border border-[#CAD0D9] rounded-lg"
            onChange={handleChange}
            required
          />
          <input
            type="text"
            placeholder="ZipCode*"
            name="zipcode"
            value={formData.zipcode}
            className="w-full px-4 py-2 2xl:py-3 2xl:text-lg mb-4 border border-[#CAD0D9] rounded-lg"
            onChange={handleChange}
            required
          />
          <input
            type="text"
            placeholder="Phone"
            name="phone"
            value={formData.phone}
            className="w-full px-4 py-2 2xl:py-3 2xl:text-lg mb-4 border border-[#CAD0D9] rounded-lg"
            onChange={handleChange}
          />
          <input
            type="text"
            placeholder="Website*"
            name="website"
            value={formData.website}
            className="w-full px-4 py-2 2xl:py-3 2xl:text-lg mb-4 border border-[#CAD0D9] rounded-lg"
            onChange={handleChange}
            required
          />
          <div className="flex items-center gap-2 mb-2">
            <label
              htmlFor="thumbnail-banner-image"
              className="flex-1 flex items-center px-4 py-2 2xl:py-3 2xl:text-lg border border-[#CAD0D9] rounded-lg cursor-pointer"
            >
              <span className="flex-grow text-[#9CA3AF]">
                {formData.logo && formData.logo.name ? formData.logo.name : 'Upload your Logo'}
              </span>
              <input
                type="file"
                id="thumbnail-banner-image"
                className="hidden"
                accept="image/*"
                name="logo"
                onChange={handleFileChange}
              />
            </label>
            {file && (
              <button
                onClick={handleRemoveFile}
                className="px-3 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
              >
                X
              </button>
            )}
          </div>
          
          <p className="text-sm text-left py-0 2xl:py-3 2xl:text-md mb-4">
            Image size should be 250x100 px. The file should be in jpg,jpeg, or png format with a maximum size 2mb.
          </p>
          <div className="flex justify-between gap-4">
            <button
              type="button"
              className="w-full px-4 py-2 2xl:py-3 2xl:text-lg 2xl:mb-4 text-white bg-[#5D5D5D] rounded-lg hover:bg-[#4B4B4B] transition-colors"
              onClick={handleBackClick}
            >
              Back
            </button>
            <button
              type="submit"
              className="w-full px-4 py-2 2xl:py-3 2xl:text-lg 2xl:mb-4 text-white bg-[#5D5D5D] rounded-lg hover:bg-[#4B4B4B] transition-colors"
            >
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CompanyDetailsForm2;